export const endpoint = ""

export const bizDetails = {
    name: "Omer Gardening",
    description: "حديقه احلامك تبدأ هنا",
    socialBtns : {
        call: "اتصل",
        wsp: "واتساب",
        ig: "انستاغرام",
        fb: "فيسبوك",
        website: "الموقع",
        tiktok:"تيكتوك",
        menu:"المنيو",
        waze:"وييز",
        mail: "ايميل",
        review: "قييمنا",
        meeting: "عين موعد"
    },
    saveBtnText: "ضيفني لجهات الاتصال",
    orderNowText: "أطلب منا الأن"
}

export const bizDetails_He = {
    name: "עומר גינון",
    description: "גינת החלומות שלכם מתחילה כאן",
    socialBtns : {
        call: "שיחה",
        wsp: "וואטספ",
        ig: "אינסטגרם",
        fb: "פייסבוק",
        website: "האתר",
        tiktok:"טיקטוק",
        menu:"קטלוג",
        waze:"וואיז",
        mail: "מייל",
        review: "דרג אותנו",
        meeting: "פגישה"
    },
    saveBtnText: "הוסף אותנו לאנשי קשר",
    orderNowText: "הזמן שירות עכשיו"
}

export const bizDetails_En = {
    name: "Omer Gardening",
    description: "Your dream garden starts here.",
    socialBtns : {
        call: "Call Us",
        wsp: "WSP",
        ig: "IG",
        fb: "FB",
        website: "Website",
        tiktok:"Tiktok",
        menu:"catalog",
        waze:"Waze",
        mail: "Mail",
        review: "Rate Us",
        meeting: "Meet Us"
    },
    saveBtnText: "Add Us To Contacts",
    orderNowText: "Order a Service"
}

export const contact = {
    name: "עומר גינון",
    phone: "972543982268",
    email: "omergenon@gmail.com",
    website: "https://website. com/",
    ig:"omergenon",
    fb:"omergenon",
    tiktok:"@omer_gardening",
    menu:"https://catalog.omergenon.co.il",
    waze: "waze.com",
};

export const schedule = {
    link:"https://.com",
    title:"קביעת פגישה אונליין",
}

export const footer = {
    desclaimer: "برمجه وتصميم",
    copywrites: "كيوبي ميديا"
}

export const footer_He = {
    desclaimer: "פיתוח ועיצוב על ידי",
    copywrites: "קיובי מדיה"
}

export const socialAccounts = {
    wsp:`https://api.whatsapp.com/send?phone=${contact.phone}`,
    ig:`http://instagram.com/${contact.ig}`,
    fb:`https://facebook.com/${contact.fb}`,
    tiktok:`https://www.tiktok.com/${contact.tiktok}`,
}